import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import AppLogo from './AppLogo';

function Footer() {
  const year = new Date().getFullYear();
  const [email, setEmail] = useState('');
  const [submitted, setSubmitted] = useState(false);

  const onSubmit = (e) => {
    e.preventDefault();
    if (!email.trim()) return;
    setSubmitted(true);
    setEmail('');
    setTimeout(() => setSubmitted(false), 4000);
  };

  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-newsletter">
          <div>
            <h3>Get build tips & app updates</h3>
            <p>One short email a month. New calculators, design templates and pro tips. No spam, unsubscribe anytime.</p>
          </div>
          <form className="newsletter-form" onSubmit={onSubmit}>
            <input
              type="email"
              placeholder={submitted ? "Thanks — you're subscribed!" : "you@example.com"}
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              aria-label="Email address"
            />
            <button type="submit">{submitted ? '✓ Subscribed' : 'Subscribe'}</button>
          </form>
        </div>

        <div className="footer-grid">
          <div>
            <div className="footer-brand">
              <AppLogo />
              <strong>Construction Calculator</strong>
            </div>
            <p className="footer-tagline">
              Smart, accurate construction estimates in your pocket.
              Built for builders, engineers and homeowners.
            </p>
            <div className="footer-socials">
              <a href="https://play.google.com/store/apps/details?id=com.fairappsstore.construction_calculator" target="_blank" rel="noopener noreferrer" className="footer-social" aria-label="Google Play">
                <svg viewBox="0 0 24 24" fill="currentColor"><path d="M3.6 1.7c-.4.3-.6.8-.6 1.4v17.8c0 .6.2 1.1.6 1.4l9.7-9.7L3.6 1.7zm10.8 10.8 2.7 2.7-12 6.8 9.3-9.5zM3.6 1.7l9.7 9.5 2.7-2.7L3.6 1.7zm14.7 8.6 2.7 1.6c.7.4.7 1.4 0 1.8l-2.7 1.6-2.9-2.5 2.9-2.5z"/></svg>
              </a>
              <a href="https://apps.apple.com/app/id6763050323" target="_blank" rel="noopener noreferrer" className="footer-social" aria-label="App Store">
                <svg viewBox="0 0 24 24" fill="currentColor"><path d="M17.05 20.28c-.98.95-2.05.86-3.08.4-1.09-.47-2.09-.48-3.24 0-1.44.62-2.2.44-3.06-.4C2.79 15.25 3.51 7.59 9.05 7.31c1.35.07 2.29.74 3.08.8 1.18-.24 2.31-.93 3.57-.84 1.51.12 2.65.72 3.4 1.8-3.12 1.87-2.38 5.98.48 7.13-.57 1.5-1.31 2.99-2.54 4.09zM12.03 7.25c-.15-2.23 1.66-4.07 3.74-4.25.29 2.58-2.34 4.5-3.74 4.25z"/></svg>
              </a>
              <a href="mailto:support@fairappsstore.com" className="footer-social" aria-label="Email">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"/><polyline points="22,6 12,13 2,6"/></svg>
              </a>
              <a href="https://x.com" target="_blank" rel="noopener noreferrer" className="footer-social" aria-label="Twitter">
                <svg viewBox="0 0 24 24" fill="currentColor"><path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z"/></svg>
              </a>
            </div>
          </div>
          <div>
            <h4>Product</h4>
            <Link to="/">Home</Link>
            <Link to="/about">About</Link>
            <Link to="/download">Download</Link>
            <Link to="/support">Support</Link>
          </div>
          <div>
            <h4>Get the app</h4>
            <a href="https://play.google.com/store/apps/details?id=com.fairappsstore.construction_calculator" target="_blank" rel="noopener noreferrer">Google Play</a>
            <a href="https://apps.apple.com/app/id6763050323" target="_blank" rel="noopener noreferrer">App Store</a>
            <a href="mailto:support@fairappsstore.com">Email Support</a>
          </div>
          <div>
            <h4>Legal</h4>
            <Link to="/terms">Terms &amp; Conditions</Link>
            <Link to="/privacy">Privacy Policy</Link>
          </div>
        </div>

        <div className="footer-bottom">
          <span>© {year} Construction Calculator. All rights reserved.</span>
          <div className="footer-bottom-links">
            <Link to="/terms">Terms</Link>
            <Link to="/privacy">Privacy</Link>
            <Link to="/support">Support</Link>
          </div>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
